// extracted by mini-css-extract-plugin
export default {"container":"ZO-z","topReviewHeading":"_O-z","criticalReview":"aP-z","favorableReview":"bP-z","vsSeparator":"cP-z"};